export class ExportModel {

    public isInit: boolean = true;
    public apiKey: string;

}